import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import useCallbackRef from 'hooks/useCallbackRef';
import { Button, Modal } from 'ncoded-component-library';
import { OverlayRef } from 'ncoded-component-library/build/components/atoms/Overlay/Overlay.component';
import { useTranslation } from 'react-i18next';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';
import { getUserFullNameOrEmail } from 'utils';

type UseViewAsProps = {
  buySideMembers: DataRoomMember[];
  updateBuySidePreviewMember: (value: DataRoomMember) => void;
};

const useViewAsFiles = (props: UseViewAsProps) => {
  const { buySideMembers, updateBuySidePreviewMember } = props;
  const { t } = useTranslation();

  const [selectedMember, setSelectedMember] = useState<DataRoomMember>(null);
  const [viewAs, viewAsModalRef] = useCallbackRef<OverlayRef>();

  const viewAsModal = useMemo(
    () => (
      <Modal
        className="data-room-view-as-modal"
        title={t('viewTheirAccess')}
        ref={viewAsModalRef}
      >
        <ul className="members">
          {buySideMembers.map((member) => (
            <li
              key={member._id}
              className={classNames({
                'members--selected': selectedMember?._id === member._id,
              })}
              onClick={() => setSelectedMember(member)}
            >
              {getUserFullNameOrEmail(member) || t('unknownUser')}
            </li>
          ))}
        </ul>

        <div className="actions">
          <Button
            disabled={!selectedMember}
            onClick={() => {
              updateBuySidePreviewMember(selectedMember);
              viewAs.close();
            }}
          >
            {t('viewAs', { name: '' })}
          </Button>
          <Button variant="link" onClick={() => viewAs.close()}>
            {t('close')}
          </Button>
        </div>
      </Modal>
    ),
    [
      buySideMembers,
      selectedMember,
      updateBuySidePreviewMember,
      t,
      viewAs,
      viewAsModalRef,
    ],
  );

  const openViewAsModal = useCallback(() => viewAs.open(), [viewAs]);

  return { viewAsModal, openViewAsModal };
};

export default useViewAsFiles;
